export default __webpack_public_path__ + "static/B0248-9bfe9c468ca90ec167e4cdcbd8f465cf.png";